<template>
    <div>
        <div style="max-width: 900px; padding: 1%; margin: 0 auto">
            <div style="background: #FAFAFA; padding: 20px">
                <div class="content">
                    <h1>
                        <FilePdfOutlined style="color: #c4302e"/> <b>Pdf解析中</b>
                        <a-space>
                            <LoadingComponent v-if="loading"/>
                        </a-space>
                    </h1>

                    <p>
                        您上传的文献正在解析中，完成后将自动跳转。
                    </p>
                    <a-steps :current="status">
                        <a-step title="提交">
                            <template #icon>
                                <FilePdfOutlined />
                            </template>
                        </a-step>
                        <a-step title="解析文本">
                            <template #icon>
                                <solution-outlined />
                            </template>
                        </a-step>
                        <a-step title="存入文献库">
                            <template #icon>
                                <FileDoneOutlined />
                            </template>
                        </a-step>
                        <a-step title="更新视频">
                            <template #icon>
                                <video-camera-outlined />
                            </template>
                        </a-step>
                        <a-step title="更新音频">
                            <template #icon>
                                <audio-outlined />
                            </template>
                        </a-step>
                        <a-step title="失败" v-if="status === -1">
                            <template #icon>
                                <FrownOutlined />
                            </template>
                        </a-step>

                        <a-step title="完成" v-else>
                            <template #icon>
                                <smile-outlined />
                            </template>
                        </a-step>
                    </a-steps>
                </div>
                <div class="content">
                    <p>
                        您可以复制链接：
                    </p>
                    <p>
                        <a-typography-text :copyable="{ text: href }">
                            <a :href="href" id="link">
                                {{href}}
                            </a>
                        </a-typography-text>
                    </p>
                </div>
                <div class="content">
                    <p>
                        或者长按保存二维码稍后查看结果：
                        <paper-qrcode/>
                    </p>
                </div>
            </div>


        </div>
    </div>

    <div style="height: 1px; opacity: 0">
        <input type="text" :value="link" class="link">
    </div>
</template>
<script>
    import { defineComponent } from 'vue';
    import {FilePdfOutlined, AudioOutlined, FileDoneOutlined, VideoCameraOutlined, FrownOutlined} from '@ant-design/icons-vue';
    import {
        get_biogpt_upload_status,
        post_biogpt_upload_share
    } from "../utils/bioinfo.api";
    import {jy_tip} from "../utils/vue.tool";
    import {get_args} from "../utils/request";
    import LoadingComponent from '../components/LoadingComponent'
    import PaperQrcode from "./PaperQrcode";
    export default defineComponent({
        name: "LiteratureUpload",
        props: ['upload'],
        components: {
            FilePdfOutlined,
            LoadingComponent,
            PaperQrcode,
            FileDoneOutlined,
            AudioOutlined, VideoCameraOutlined, FrownOutlined
        },
        data() {
            let {upload_no, uploadno} = get_args();
            upload_no = upload_no || uploadno;
            return {
                upload_no: Number(upload_no) || this.upload,
                href: window.location.href,
                loading: true,
                status: 0,
                qrcode: '',
            };
        },
        created(){
            this.getStatus();
        },
        methods: {
            getStatus(){
                let {upload_no, status} = this;
                if(status < 2) {
                    get_biogpt_upload_status({upload_no}, (res)=>{
                        let {data, message} = res;
                        if(data){
                            let {status: newStatus} = data;
                            if(newStatus < 2) {
                                setTimeout(()=>{
                                    this.getStatus();
                                }, 5000)
                            }
                            else {
                                this.loading = false;
                                this.overviewDetail(data);
                            }
                        } else jy_tip(message);
                    })
                }
            },

            overviewDetail(record){
                console.log(record);
                let {upload_no, paper_no} = record;
                post_biogpt_upload_share({upload_no, paper_no}, (res)=>{
                    let {data, message} = res;
                    if(data){
                        let {share_code} = data;
                        if(share_code) window.location.href = ('/push/paper/?share_code=' + share_code + '&paper_no=' + paper_no + '&upload_no=' + upload_no);
                        else jy_tip('生成分析码失败: ' + message);
                    } else jy_tip('分享失败: ' + message);
                })
            },
        }
    });
</script>

<style scoped>
    .content{
        background: #FFF;
        border-radius: 10px;
        margin-bottom: 10px;
        padding: 20px 10px;
    }
</style>
